module.exports = __webpack_public_path__ + "img/fold.dd3f5f61.svg";